export const MAPBOX_MAP_STYLE_KEY_TRIPX = 'tripx_custom';
export const MAPBOX_MAP_STYLE_KEY_SATELITE = 'satelite';
